import { Pipe, PipeTransform } from '@angular/core';
import { ScrEnvironment } from 'src/environments/environment';
import { PhoneNumber, PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { StringOrPhoneNumber } from '../models/common.model';

/**
 * Transform the input string or phone phone number JSON object into
 * national or (international for Sd) format to display in read-only form.
 */

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

  constructor(private environment: ScrEnvironment) {
    // nothing to do
  }

  transform(value?: StringOrPhoneNumber): string | undefined {
    if (!value) {
      return value;
    }
    const util = new PhoneNumberUtil();
    let parsed: PhoneNumber;
    if (typeof value === 'string') {
      try {
        parsed = util.parse(value);
        if (!parsed) {
          return value;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      catch (e) {
        return value;
      }
    }
    else {
      try {
        parsed = util.parse(value.e164Number);
        if (!parsed) {
          return value.e164Number;
        }
      }
      catch (e) {
        console.warn(e);
        return value.e164Number;
      }
    }

    if (this.environment.servicedesk) {
      if (parsed.getCountryCode() === 1) {
        return util.format(parsed, PhoneNumberFormat.NATIONAL);
      }
      else {
        return util.format(parsed, PhoneNumberFormat.INTERNATIONAL);
      }
    }
    else {
      return util.format(parsed, PhoneNumberFormat.NATIONAL);
    }
  }
}
